const selectTools = {
    selectInit(select) {
        if (select) {
            selectTools.selectItemInit(select)
        } else {
            $('.js_select').each((i, el) => {
                selectTools.selectItemInit($(el))
            })
        }
    },

    selectItemInit(select) {
        let wrapper = $('<div class="global__select-wrapper"></div>')
        let input = $(`<div class="global__select-input">${select.find('option:selected').text()}</div>`)
        let listWrapper = $('<div class="global__select-list-wrapper"></div>')
        let list = $('<ul class="global__select-list global__scroll"></ul>')
        select.find('option').each((ind, elem) => {
            if (!$(elem).is(':disabled')) {
                let item = $(`<li class="global__select-item" data-val="${$(elem).attr('value')}">${$(elem).text()}</li>`)
                item.appendTo(list)
            }
        })
        if (select.attr('data-search')) {
            let search = $(`<input class="global__select-search" type=text placeholder="${select.attr('data-search')}">`)
            list.prepend(search)
        }
        listWrapper.append(list)
        wrapper.append(input).append(listWrapper)
        select.after(wrapper)
    },

    closeSelect(select) {
        if (select) {
            select.removeClass('active')
            select.find('.global__select-list-wrapper').slideUp(300)
            select.find('.global__select-item').removeClass('hidden')
            select.find('.global__select-search').val('')
        } else {
            $('.global__select-wrapper').removeClass('active')
            $('.global__select-list-wrapper').slideUp(300)
            $('.global__select-item').removeClass('hidden')
            $('.global__select-search').val('')
        }
    },

    searchSelect(input) {
        const select = input.closest('.global__select-wrapper')
        const items = select.find('.global__select-item')
        let value = input.val().trim().toLowerCase()
        if (value != '') {
            items.each((i, el) => {
                const text = $(el).text().trim().toLowerCase()
                text.includes(value) ? $(el).removeClass('hidden') : $(el).addClass('hidden')
            })
        } else {
            items.removeClass('hidden')
        }
    },

    openList(button) {
        let wrapper = button.closest('.global__select-wrapper')
        let list = wrapper.find('.global__select-list-wrapper')
        if (wrapper.hasClass('active')) {
            wrapper.removeClass('active')
            list.removeAttr('style')
        } else {
            wrapper.addClass('active')
            list.slideDown(300)
        }
    },

    setValue(button) {
        let wrapper = button.closest('.global__select-wrapper')
        let input = wrapper.find('.global__select-input')
        let value = button.attr('data-val')
        wrapper.prev('select').val(value).trigger('change')
        input.text(button.text())
        selectTools.closeSelect(wrapper)
    }
}

window.selectTools = selectTools

$(document).ready(function () {
    selectTools.selectInit()

    $(document).on('input', '.global__select-search', function () {
        selectTools.searchSelect($(this))
    })

    $(document).on('click', '.global__select-input', function () {
        selectTools.openList($(this))
    })

    $(document).on('click', '.global__select-item', function () {
        selectTools.setValue($(this))
    })

    $(document).on('click', function (e) {
        if (!$(e.target).closest('.global__select-wrapper').length) {
            selectTools.closeSelect()
        }
    })
})